import { FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import FleetMaintenanceRuleList from '../../fleet/rules/FleetMaintenaceRuleList';
import FleetMaintenanceRulesFiltersBar from '../../fleet/rules/FleetMaintenanceRulesFiltersBar';

function FleetRulesPage() {
  const { classes } = useStyles();

  return (
    <FullContainer
      verticalFlex
      classNames={classes.basicPageContainer}
    >
      <FleetMaintenanceRulesFiltersBar />
      <FleetMaintenanceRuleList />
    </FullContainer>
  );
}

export default FleetRulesPage;
